import BaseValidator from '@/app-core/lib/data/validator/BaseValidator'
import ValidatorTypesEnum from '@/app-core/lib/data/validator/ValidatorTypesEnum'
import {isValidMobilePhone} from '@/app-core/api/validations/CustomValidator'

export default class AccountSettingsValidator extends BaseValidator {
  validatorRules = {
    Id: {
      required: true,
      type    : BaseValidator.Type.Number
    },
    Firstname: {
      required: true,
      type    : ValidatorTypesEnum.String,
      minLen  : 2,
      maxLen  : 32
    },
    Lastname: {
      required: true,
      type    : ValidatorTypesEnum.String,
      minLen  : 2,
      maxLen  : 32
    },
    Phone: {
      required   : true,
      type       : ValidatorTypesEnum.String,
      mobilePhone: isValidMobilePhone
    },
    NewPass: {
      requiredIfNot: ['NewPassConfirm', ''],
      type         : ValidatorTypesEnum.String,
      minLen       : 8
    },
    NewPassConfirm: {
      requiredIfNot: ['NewPass', ''],
      type         : ValidatorTypesEnum.String,
      equals       : 'NewPass',
      minLen       : 8
    }
  }

  validatorMessages = {
    el: {
      mobilePhone: 'Πρέπει να είναι έγκυρος αριθμός κινητού τηλεφώνου'
    },
    en: {
      mobilePhone: 'Must be a valid mobile number'
    }
  }

  constructor(data = {}) {
    super(data)
  }
}
